import api from 'api';
import { get } from 'utils/fetch';
import { useState, useEffect, useContext } from 'react';
import { message, Spin, Input } from 'antd';
import { PropertyInsertion } from 'pages/RecordInsertion/PropertyInsertion';
import { isPhoneSize, isVAFull } from 'utils/util';
import { GlobalContext } from 'GlobalContext';
import { isAdmin, isSale } from 'utils/util';

export function PropertyManager(props) {
    const {
        setManageRecordId,
        manageRecordId,
        accessToken,
        globalId,
        refreshSession,
    } = useContext(GlobalContext);
    const { filteredText, setFilteredText } = props;
    // const [filteredText, setFilteredText] = useState('');
    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState(true);
    const [propertyId, setPropertyId] = useState(0);
    const [properties, setProperties] = useState([]);
    const [customerPropertyIds, setCustomerPropertyIds] = useState(new Set());

    function canViewAll() {
        return isAdmin() || isVAFull();
    }

    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    async function fetchProperties() {
        await get(
            api.manager.properties,
            setProperties,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
        if (canViewAll()) {
            setLoading(false);
        }
    }

    async function fetchCustomerPropertyIds() {
        await get(
            api.sale.customerAssetIds(globalId),
            (properties) => {
                setCustomerPropertyIds(new Set(properties));
            },
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
        setLoading(false);
    }

    useEffect(() => {
        if (manageRecordId !== 0) {
            setLoading(false);
        }
        //console.log(propertyId)
        // setFilteredText('');
        if (manageRecordId !== 0) return;
        fetchProperties();
        if (isSale()) {
            fetchCustomerPropertyIds();
        }
    }, [manageRecordId]);

    return (
        <>
            {loading && (
                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <Spin />
                </div>
            )}
            {!loading && manageRecordId === 0 && (
                <>
                    <div
                        style={{
                            width: '300px',
                            marginTop: '30px',
                            marginLeft: '20px',
                            display: 'flex',
                            flexDirection: 'row',
                        }}
                    >
                        <Input
                            onChange={(e) => setFilteredText(e.target.value)}
                            value={filteredText}
                            placeholder="Filter on address"
                        />
                        {filteredText && (
                            <div
                                onClick={() => setFilteredText('')}
                                style={{
                                    cursor: 'pointer',
                                    color: '#888',
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                    userSelect: 'none',
                                }}
                            >
                                ×
                            </div>
                        )}
                    </div>

                    {isAdmin() && (
                        <div style={{ margin: '20px' }}>
                            <button
                                style={{
                                    height: '30px',
                                    width: '50px',
                                    borderRadius: '30px',
                                    background: 'rgb(17 32 86)',
                                    color: 'white',
                                    cursor: 'pointer',
                                }}
                                onClick={() => setManageRecordId(-1)}
                            >
                                Add
                            </button>
                        </div>
                    )}
                    <div
                        style={{
                            height: isPhoneSize()
                                ? 'calc(100vh - 327px)'
                                : 'calc(100vh - 174px)',
                            maxHeight: isPhoneSize()
                                ? 'calc(100vh - 327px)'
                                : 'calc(100vh - 174px)',
                            minHeight: isPhoneSize()
                                ? 'calc(100vh - 327px)'
                                : 'calc(100vh - 174px)',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            display: 'block',
                            position: 'relative',
                            boxSizing: 'border-box',
                            flexShrink: 0,
                            flexGrow: 0,
                        }}
                    >
                        {properties
                            .filter((property) => {
                                if (canViewAll()) return true;
                                else if (isSale())
                                    return customerPropertyIds.has(property.id);
                            })
                            .filter((property) => {
                                if (
                                    property.address2 !== null &&
                                    property.address2.trim().length > 0
                                ) {
                                    return `${property.address} ${property.address2}, ${property.city}, ${property.state} ${property.zip}`
                                        .toLowerCase()
                                        .includes(
                                            filteredText.trim().toLowerCase()
                                        );
                                } else {
                                    return `${property.address}, ${property.city}, ${property.state} ${property.zip}`
                                        .toLowerCase()
                                        .includes(
                                            filteredText.trim().toLowerCase()
                                        );
                                }
                            })
                            .sort((a, b) => {
                                if (a.address < b.address) {
                                    return -1;
                                }
                                return 1;
                            })
                            .map((property, idx) => {
                                return (
                                    <div
                                        key={idx}
                                        style={
                                            isPhoneSize()
                                                ? {
                                                      fontSize: '20px',
                                                      margin: '20px',
                                                      width: 'fit-content',
                                                      color: 'blue',
                                                      textDecoration:
                                                          'underline',
                                                      cursor: 'pointer',
                                                  }
                                                : {
                                                      fontSize: '20px',
                                                      margin: '20px',
                                                      width: 'fit-content',
                                                      color: 'blue',
                                                      borderBottom:
                                                          '1px solid blue',
                                                      cursor: 'pointer',
                                                  }
                                        }
                                        onClick={() =>
                                            setManageRecordId(property.id)
                                        }
                                    >
                                        {property.address2 !== null &&
                                            property.address2.trim().length >
                                                0 &&
                                            `${property.address} ${property.address2}, ${property.city}, ${property.state} ${property.zip}`}
                                        {(property.address2 === null ||
                                            property.address2.trim().length <=
                                                0) &&
                                            `${property.address}, ${property.city}, ${property.state} ${property.zip}`}
                                    </div>
                                );
                            })}
                    </div>
                </>
            )}
            {!loading && manageRecordId > 0 && (
                <>
                    <PropertyInsertion
                    // property={properties.filter(property => property.id === propertyId)[0]}
                    // setPropertyId={setPropertyId}
                    />
                </>
            )}
            {!loading && manageRecordId < 0 && (
                <>
                    <PropertyInsertion
                    // property={null}
                    // setPropertyId={setPropertyId}
                    />
                </>
            )}
        </>
    );
}
